import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d0b2b2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-[100%] w-[1200px] m-auto flex items-center justify-between max-[750px]:w-[100%]" }
const _hoisted_2 = { class: "h-[60px] flex items-center nav-bar-logo" }
const _hoisted_3 = ["src"]

import {
    ref,
    defineOptions,
    watchEffect,
    onUnmounted,
    onMounted,
    computed,
    watch,
    nextTick,
} from 'vue'
import { useRouter } from 'vue-router'
import { getCurrentInstance } from 'vue'
import IndexLogo from '@/assets/images/logo.png'
import { INavList } from '@/interface/index'
import { useStore } from '@/store/index'
import { getConfig, getFacultyMenuKind } from '@/http/api/index'
import { changeThemeColor } from '@/utils/themeConfig'

export default /*#__PURE__*/_defineComponent({
  ...{
    name: 'NavBar',
},
  __name: 'NavBar',
  setup(__props) {


const store = useStore()
const { proxy } = getCurrentInstance() as any
const activeIndex = ref()
const router = useRouter()
const scrollTopValue = ref(0)
const curLogo = computed(() => {
    if (navList.value.length > 0 && navList.value[0].logo) {
        return navList.value[0].logo
    }
    return IndexLogo
})
function onScroll() {
    const scrollTop =
        document.documentElement.scrollTop || document.body?.scrollTop
    scrollTopValue.value = scrollTop
}
const navList = ref<Array<INavList>>([])
function arrToTree(arr: Array<INavList> = []) {
    arr.forEach((v: any) => {
        v.name = v.title
        if (v.parentId != 0) {
            const parentItem = arr.find((child) => child.id == v.parentId)
            if (parentItem) {
                if (parentItem.children) {
                    parentItem.children.push(v)
                } else {
                    parentItem.children = [v]
                }
            }
        }
    })
    return arr.filter((v) => !v.parentId)
}
getThemeConfig()
function getThemeConfig() {
    getConfig().then((res: any) => {
        if (res.data?.length) {
            store.commit('setConfigList', res.data)
            changeThemeColor(res.data[0].skin || '#ff0000')
        } else {
            changeThemeColor('#ff0000')
        }
    })
}
onMounted(() => {
    window.addEventListener('scroll', onScroll)
    getFacultyMenuKind().then((res: any) => {
        store.commit('setFacultyMenuKind', res.data)
        // 接口最后一条为“网站底部logo”配置项，不在顶部导航显示
        const menuData = (res.data || []).slice(0, -1)
        navList.value = arrToTree(menuData)
        proxy.$eventBus.emit('navMenuInit')
    })
})
onUnmounted(() => {
    window.removeEventListener('scroll', onScroll)
})

watch(
    () => router.currentRoute.value,
    () => {
        nextTick(() => {
            document.body.scrollTop = document.documentElement.scrollTop = 0
        })
    }
)
watchEffect(() => {
    activeIndex.value = '/' + router.currentRoute.value.path.split('/')[1]
})

const handleSelect = (key: string, keyPath: string[]) => {
  
  if(key === '/feestandards') {
    window.open('http://www.gdrising.com.cn/')
    return
  }

  router.push(key)
}

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fixed top-0 left-0 z-50 justify-between w-[100%] h-[80px] nav-bar-wrap", [scrollTopValue.value > 0 ? 'bg-white' : 'bg-white/50']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: curLogo.value,
          class: "h-[47px]"
        }, null, 8, _hoisted_3)
      ]),
      _createVNode(_component_el_menu, {
        ellipsis: navList.value.length > 8,
        "default-active": activeIndex.value,
        class: "el-menu-demo",
        mode: "horizontal",
        onSelect: handleSelect
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (
                            !item.children ||
                            item.children.length === 0 ||
                            item.children.length > 0
                        )
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    index: item.path,
                    key: item.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["index"]))
                : (_openBlock(), _createBlock(_component_el_sub_menu, {
                    index: item.path,
                    key: item.id
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.title), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (demo) => {
                        return (_openBlock(), _createBlock(_component_el_menu_item, {
                          index: demo.path,
                          key: 'child' + demo.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(demo.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["index"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["index"]))
            ], 64))
          }), 256))
        ]),
        _: 1
      }, 8, ["ellipsis", "default-active"])
    ])
  ], 2))
}
}

})